import { createContext } from "react";
import { HexMap } from "../../Data/HexMap/HexMap";
import DisplayConfig from "../../Data/HexMap/DisplayConfig";

export const DisplayContext = createContext<DisplayConfig>(new DisplayConfig({keyRadius:50}));